import type { AxiosRequestConfig } from 'axios'

export const API_URL = import.meta.env.VITE_API_URL

export const API_URL_V1 = `${API_URL}/v1/`
export const API_PMS_URL = `${API_URL}/v1/be/rpc`

export const accessApiKey = import.meta.env.VITE_API_KEY
export const authType = import.meta.env.VITE_AUTH_TYPE

export let API_HEADERS:AxiosRequestConfig  = {
    headers: {
        'Content-Type': 'application/json',
        'Authorization': `${authType} ${accessApiKey}`,
    }
}

